import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const InvoiceUnreceivedRule = (props) => {
  const {
    form, type, onSubmit, initialValues, ...other
  } = props;
  const [numberDays, setNumberDays] = useState(initialValues.number_days || 5);
  const [regions, setRegions] = useState(
    !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
  );

  const submit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'invoice_unreceived',
      regions: _.filter(regions),
      value: {
        number_days: numberDays
      }
    });
  }, [numberDays, onSubmit, regions]);

  const onReset = useCallback(() => {
    setNumberDays(initialValues.number_days || 5);
    setRegions(
      !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
    );
  }, [initialValues.number_days, initialValues.regions]);


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        value={regions}
        onChange={setRegions}
      />
      <InlineInputNumber
        label='Number of Days'
        description='Must be between 1-28'
        value={numberDays}
        onChange={setNumberDays}
      />
    </RuleForm>
  );
};

InvoiceUnreceivedRule.defaultProps = {
  type: 'add',
  initialValues: {
    number_days: 5
  }
};

InvoiceUnreceivedRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default InvoiceUnreceivedRule;
